import { combineReducers } from 'redux';

import data from './data';
import ui from './ui';

/**
 * @typedef {{
 *   data: import('./data').QuestionModelsDataReducer,
 *   ui: import('./ui').QuestionModelUIReducer
 * }} QuestionModelReducer
 */

export default combineReducers({
  data,
  ui,
});
